import { PlatformPage } from './PlatformPage'
import { OverviewTab } from './tabs/OverviewTab'

export function OverviewPage() {
  return (
    <PlatformPage title="Overview" description="Platform-wide statistics and recent activity.">
      <OverviewTab />
    </PlatformPage>
  )
}
